module.exports = __webpack_public_path__ + "static/media/logo-recovinyl.ec879087.png";